<template>
  <div class="frame">
    <div class="full-width-container">
      <div class="container1">
        <div class="dark-mode-toggle">
          <button 
            :class="['dark-mode-button', isDarkMode ? 'dark-active' : 'light-active']"
            @click="toggleDarkMode"
            :title="isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
          >
            <span class="dark-mode-label light">Light</span>
            <span class="dark-mode-label dark">Dark</span>
            <span :class="['dark-mode-slider', isDarkMode ? 'dark' : 'light']"></span>
          </button>
        </div>
      </div>
      <div class="container-center">
        <img id="logo" :src="require('@/assets/images/logo.png')" alt="Logo" @click="goHomeFromLogo">
      </div>
      <div class="container2">
        <div 
          v-for="(item, index) in navItems" 
          :key="index" 
          :class="[navVisList[index] === false ? 'hidden-component' : 'nav-group']" 
          @click="handleNavClick(index)"
        >
          <div :class="[navActiveList[index] === true ? 'active icon-container' : 'icon-container']">
            <font-awesome-icon :icon="item.icon" class="custom-icon" />
          </div>
          <p :class="[navActiveList[index] === true ? 'active' : '']">{{ item.label }}</p>
        </div>
      </div>
      <div class="container3">
        <div class="env-toggle" v-if="shouldShowEnvToggle">
          <button 
            :class="['env-button', isDevMode ? 'dev-active' : 'prod-active']"
            @click="toggleEnvironment"
          >
            <span class="env-label prod">PRD</span>
            <span class="env-label dev">DEV</span>
            <span :class="['toggle-slider', isDevMode ? 'dev' : 'prod']"></span>
          </button>
        </div>
        <div class="user-container">
          <div class="icon-container">
            <font-awesome-icon :icon="['fas', 'user']" class="custom-icon" />
          </div> 
          <div class="user-info">
            <span class="user-name"><p>Hi {{ firstName }}</p></span>
            <button class="logout-button" @click="logout"><p>Log Out</p></button>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import { getUserInfo, clearUserInfo, getDevModeState, setDevModeState } from '@/services/cookieService';
import { eventBus } from '@/services/eventBus';
import { isValidString, isValidNumber } from '@/services/helperFunctions';
import darkModeService from '@/services/darkModeService';


export default {
  name: 'MainTopHeader',
  data() {
    return {
      navActiveList: [true, false, false],
      navVisList: [true, false, false],
      navItems: [
        { icon: ['fas', 'list-check'], label: 'Home' },
        { icon: ['fas', 'line-chart'], label: 'Visualization' },
        // { icon: ['fas', 'list-check'], label: 'Configuration' },
        { icon: ['fas', 'dice-d20'], label: 'Lab'},
      ],
      cookieData: null,
      firstName: 'User',
      isLogoutVisible: false,
      isDevMode: false,
      access_level: 0,
      isDarkMode: false,
      darkModeObserver: null,
    };
  },
  methods: {
    goHomeFromLogo() {
      if (this.$route.name !== 'HomePage') {
        this.$router.push({ name: 'HomePage' });
      }
      this.navActiveList = [true, false, false];
      this.updateNavigationVisibility();
    },
    handleNavClick(index) {
      // console.log('Index:', index);
      switch (index) {
        case 0:
          if(this.$route.name !== 'HomePage'){
            this.$router.push({ name: 'HomePage' });
            this.navActiveList = [true, false, false];
            this.navVisList = [true, false, true];
          }
          break;
        case 1:
          if(this.$route.name !== 'DetailPage' && this.$route.name !== 'DetailPageLegacy'){
            this.$router.push({ name: 'DetailPage' });
            this.navVisList = [true, true, true];
            this.navActiveList = [false, true, false];
          }
          break;
        // case 2:
        //   if(this.$route.name !== 'DataExtractorPage'){
        //     this.$router.push({ name: 'DataExtractorPage' });
        //     this.navVisList = [true, false, true, true];
        //     this.navActiveList = [false, false, true, false];
        //   }
        //   break;
          case 2:
          // Only allow Lab navigation if user has access level 10
          if (this.access_level == 10 && this.$route.name !== 'LabPage'){
            this.$router.push({ name: 'LabPage' });
            this.updateNavigationVisibility();
            this.navActiveList = [false, false, true];
          }
          break;
        default:
          break;
      }
    },
    checkRouteValue() {
    // Get the current URL path
    const pathname = window.location.pathname; // Path (e.g., /detail)
    // console.log('Pathname:', pathname, 'Length:', pathname.length);

    switch (pathname) {
      case '/detail':
      case '/detail-legacy':
        this.updateNavigationVisibility();
        this.navActiveList = [false, true, false];
        const searchParams = new URLSearchParams(window.location.search);

        // Get specific query parameters
        const alias = searchParams.get('alias');
        const plantId = searchParams.get('plant_id'); 
        // console.log('Pool Alias:', alias);
        // console.log('Plant ID:', plantId);

        // Validate the parameters
        const isPoolAliasValid = isValidString(alias);
        const isPlantIdValid = isValidNumber(plantId);

        if (!isPoolAliasValid || !isPlantIdValid) {
          // console.log('Invalid pool alias or plant ID.');
          this.handleNavClick(0);
        }
        break;

      case '/system-configuration':
        this.updateNavigationVisibility();
        this.navActiveList = [false, false, true];
        break;

      case '/retailer':
        this.updateNavigationVisibility();
        this.navActiveList = [false, false, false];
        break;

      case '/lab':
        // Only allow access to Lab if user has access level 10
        if (this.access_level == 10) {
          this.updateNavigationVisibility();
          this.navActiveList = [false, false, true];
        } else {
          this.$router.push({ name: 'HomePage' });
        }
        break;

      case '/home':
        this.updateNavigationVisibility();
        this.navActiveList = [true, false, false];
        break;

      case '/lab/data-extractor':
        // Only allow access to Lab pages if user has access level 10
        if (this.access_level == 10) {
          this.updateNavigationVisibility();
          this.navActiveList = [false, false, true];
        } else {
          this.$router.push({ name: 'HomePage' });
        }
      break;
      
      case '/lab/ai-onboarding-evaluator':
        // Only allow access to Lab pages if user has access level 10
        if (this.access_level == 10) {
          this.updateNavigationVisibility();
          this.navActiveList = [false, false, true];
        } else {
          this.$router.push({ name: 'HomePage' });
        }
      break;

      case '/performance-report':
        this.updateNavigationVisibility();
        this.navActiveList = [false, false, true];
      break;

      case '/advanced-capabilities':
        if (this.access_level == 10) {
          this.updateNavigationVisibility();
          this.navActiveList = [true, false, false];
        } else {
          this.$router.push({ name: 'HomePage' });
        }
      break;

      case '/dev/api-tester':
        if (this.access_level == 10) {
          this.updateNavigationVisibility();
          this.navActiveList = [true, false, false];
        } else {
          this.$router.push({ name: 'HomePage' });
        }
      break;

      default:
        this.updateNavigationVisibility();
        this.navActiveList = [true, false, false];
        this.$router.push({ name: 'HomePage' });
        break;
    }
    },
    logout() {
      clearUserInfo();
      this.firstName = 'User';
      this.$emit('logout');
      this.$router.push({ name: 'LoginPage' });
    },
    readFromCookies() {
      this.cookieData = getUserInfo();
      if (this.cookieData) {
        this.firstName = this.cookieData.firstName;
        this.access_level = this.cookieData.accessLevel;
      }
      
      const devModeState = getDevModeState();
      if (devModeState.isDevMode !== undefined) {
        this.isDevMode = devModeState.isDevMode;
      }
    },
    updateNavigationVisibility() {
      // Visualization menu item (index 1) is visible when on DetailPage
      // Lab menu item (index 2) is only visible to access level 10
      // Only update if we have a valid access level
      if (this.access_level !== undefined && this.access_level !== null) {
        // Check if we're on DetailPage route
        const isOnDetailPage = this.$route && (
          this.$route.name === 'DetailPage' ||
          this.$route.name === 'DetailPageLegacy' ||
          this.$route.path === '/detail' ||
          this.$route.path === '/detail-legacy'
        );
        const showVisualization = isOnDetailPage;
        
        if (this.access_level == 10) {
          this.navVisList = [true, showVisualization, true];
        } else {
          this.navVisList = [true, showVisualization, false];
        }
      }
    },
    
    refreshUserInfo() {
      // Just refresh from cookies, then update visibility
      this.readFromCookies();
      this.updateNavigationVisibility();
    },
    handleTempSimulatorDevelopment() {
        if(this.firstName === 'Elmar'){
          this.navItems.push({ icon: ['fas', 'dice-d20'], label: 'Simulator' });
      }
      },
    toggleEnvironment() {
      this.isDevMode = !this.isDevMode;
      setDevModeState({ isDevMode: this.isDevMode });
      // Emit an event to notify other components about the environment change
      eventBus.emit('environment-changed', this.isDevMode);
    },
    toggleDarkMode() {
      this.isDarkMode = darkModeService.toggle();
    },
  },
  computed: {
    shouldShowEnvToggle() {
      // Hide toggle if API URL is "https://ai2.redxvpp.com"
      const apiUrl = process.env.VUE_APP_API_URL;
      return this.access_level == 10 && apiUrl !== "https://ai2.redxvpp.com";
    },
  },
  created() {
    eventBus.on('nav-click', this.handleNavClick);
    this.readFromCookies();
    this.checkRouteValue();
    // this.handleTempSimulatorDevelopment();
  },
  mounted() {
    // Ensure navigation visibility is updated after component is mounted
    this.updateNavigationVisibility();
    // Initialize dark mode state after mount to ensure DOM is ready
    this.isDarkMode = darkModeService.isDarkMode();
    // Also listen for changes to dark mode class on document
    this.darkModeObserver = new MutationObserver(() => {
      this.isDarkMode = darkModeService.isDarkMode();
    });
    this.darkModeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  },
  beforeUnmount() {
    if (this.darkModeObserver) {
      this.darkModeObserver.disconnect();
    }
  },
  beforeUnmount() {
    eventBus.off('nav-click', this.handleNavClick);
  },
  watch: {
    $route(to, from) {
      // Update navigation visibility when route changes
      this.updateNavigationVisibility();
      // Recalculate active nav state from current route
      this.checkRouteValue();
    }
  },
};
</script>

<style scoped lang="scss">
.frame {
  display: flex;
  background-color: black;
  color: white;
  box-sizing: border-box;
  padding: 40px 0;
}

.full-width-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.container1 {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 40px;
}

.container-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

#logo {
  width: 47%;
  max-width: 170px;
  cursor: pointer;
}

.container2 {
  margin-top: 40px;
  flex: 2;
  position: absolute;
  background: black;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.nav-group {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.active {
  color: rgb(48, 244, 139);
  cursor: not-allowed;
}

.hidden-component {
  display: none;
}

.container3 {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}

.dark-mode-toggle {
  display: flex;
  align-items: center;
  padding: 0;
  height: 32px;
}

.dark-mode-button {
  position: relative;
  width: 130px;
  height: 32px;
  border: 2px solid var(--border-color);
  border-radius: 16px;
  background: var(--card-bg);
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark-mode-button:hover {
  border-color: var(--border-color);
}

.dark-mode-label {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8em;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 1;
  width: 40px;
  text-align: center;
  color: var(--text-secondary);
}

.dark-mode-label.light {
  left: 10px;
}

.dark-mode-label.dark {
  right: 10px;
}

.dark-mode-slider {
  position: absolute;
  top: 2px;
  width: 66px;
  height: 24px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.dark-mode-slider.light {
  left: 2px;
  background-color: #6B7280;
}

.dark-mode-slider.dark {
  left: 58px;
  background-color: #6B7280;
}

.light-active .dark-mode-label.light,
.dark-active .dark-mode-label.dark {
  color: #fff;
}

.env-toggle {
  display: flex;
  align-items: center;
  margin-right: 20px;
  padding: 0;
  height: 32px;
}

.env-button {
  position: relative;
  width: 130px;
  height: 32px;
  border: 2px solid var(--border-color);
  border-radius: 16px;
  background: var(--card-bg);
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.env-label {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8em;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 1;
  width: 40px;
  text-align: center;
}

.env-label.prod {
  left: 10px;
  color: var(--text-secondary);
}

.env-label.dev {
  right: 10px;
  color: var(--text-secondary);
}

.toggle-slider {
  position: absolute;
  top: 2px;
  width: 66px;
  height: 24px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.toggle-slider.prod {
  left: 2px;
  padding: 10px;
  background-color: #20cc20;
}

.toggle-slider.dev {
  left: 58px;
  background-color: #ff4444;
}

.env-button:hover {
  border-color: var(--border-color);
}

.dev-active .env-label.dev,
.prod-active .env-label.prod {
  color: #fff;
}

.user-container {
  display: flex;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
}

.logout-button {
  display: none;
  background-color: rgb(244, 4, 4);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin: 10px;
}

.user-info:hover .logout-button {
  display: block;
}

.nav-group > p {
  font-size: 0.4em;
  font-weight: 700;
}

.custom-icon {
  font-size: 0.6em;
}

.icon-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border: 2px solid #f9f8f8;
  border-radius: 50%;
  margin: 10px;
}

.menu-toggle {
  cursor: pointer;
  margin-left: 10px;
}

@media (min-width: 950px) {
  .frame {
    height: 50px;
  }

  .container2 {
    margin-top: 0px;
    display: flex;
    flex-direction: row;
    position: static;
    gap: 7px;
  }

  .nav-group > p {
    font-size: 0.7em;
    font-weight: 700;
  }

  .custom-icon {
    font-size: 0.5em;
  }

  .icon-container {
    width: 28px;
    height: 28px;
  }

  .menu-toggle {
    display: none;
  }
}
</style>
